import axios from 'axios';
import { Tile } from '../interfaces';

export const getTilesSourcesData = (url: string): Promise<Tile[]> => {
    return axios.get(url).then((response: any) => {
        return response.data;
    });
};
